export default __webpack_public_path__ + "static/media/image-084.0e2a49c2.jpg";